<template>
    <el-table :data="dataTableLocal">
        <el-table-column prop="name" label="">
            <template slot-scope="scope">
                <div class="font-weight-bold">
                    {{ scope.row.View.DisplayName }}
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="value" label="">
            <template slot-scope="scope">
                {{scope.row.Value}}
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
    export default {
        props: [ 'dataTable' ],
        data () {
            return {
                dataTableLocal: []
            }
        },
        created () {
            this.dataTableLocal = this.dataTable.filter(row => row.View.Visible == true)
        }
    }
</script>

<style scoped>

</style>
